import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a751a928295d50014d45c0c_1788968020428_59fff058/celsoft/src/app/sign-up-login-screen/page.tsx");
